import Vue, { DirectiveOptions } from 'vue';
import MuRow from './components/grid/row.vue';
import MuCol from './components/grid/col.vue';
import MuBtn from './components/button/index.vue';
import MuToast from './components/toast';
import MuBtnBar from './components/button/bar.vue';
import MuTag from './components/tag/index.vue';
import MuImage from './components/image/index.vue';
import MuCarousel from './components/carousel/index.vue';
import MuPagination from './components/pagination/index.vue';
// import DtCollapse from './components/Collapse/index.vue';
// import DtCollapseItem from './components/Collapse/CollapseItem.vue';
import MuFormItem from './components/form/form-item.vue';
import MuInput from './components/form/field/input.vue';
import MuSelect from './components/form/field/select.vue';
import MuSelectInput from './components/form/field/select-input.vue';
import MuInputPassword from './components/form/field/password.vue';
import MuTextarea from './components/form/field/textarea.vue';
import MuCheckbox from './components/form/field/checkbox.vue';
import MuInputNumber from './components/form/field/input-number.vue';
import MuRadio from './components/form/field/radio.vue';
import MuDatepicker from './components/form/field/datepicker.vue';
import MuTimepicker from './components/form/field/timepicker.vue';
import MuSwitch from './components/form/field/switch.vue';
import MuCascader from './components/form/field/cascader.vue';
import MuSelectTree from './components/form/field/select-tree.vue';
import MuSelectTable from './components/form/field/select-table.vue';
import MuSelectAdd from './components/form/field/select-add.vue';
import MuSearchHigh from './components/form/field/search-high.vue';
import MuSearchInput from './components/form/field/search-input.vue';
import MuRadioGroup from './components/form/field/radio-group.vue';
import MuForm from './components/form/index.vue';
import MuTable from './components/table/index.vue';
import MuTableColumn from './components/table/column.vue';
// import DtField from './components/Form/Field';
import MuDialog from './components/dialog/index.vue';
import MuTabs from './components/tab/index.vue';
import MuFilterBar from './components/filter-bar/index.vue'
import MuTooltip from './components/tooltip/index.vue'
import MuTree from './components/tree/index.vue';
// import DtTemplate from './components/Template/index.vue';
import MuTreeSelect from './components/tree-select/index.vue'
// import DtIcon from './components/Icon/index.vue';
import * as prototype from './common/tool';
import * as directives from './common/directives';

const components = {
  MuRow,
  MuCol,
  MuBtn,
  MuBtnBar,
  MuTag,
  MuImage,
  MuCarousel,
  MuPagination,
  // DtCollapse,
  // DtCollapseItem,
  MuFormItem,
  MuInput,
  MuSelect,
  MuSelectInput,
  MuInputPassword,
  MuTextarea,
  MuInputNumber,
  MuForm,
  MuTable,
  MuTableColumn,
  // DtField,
  MuDialog,
  MuTabs,
  MuFilterBar,
  MuTooltip,
  MuRadio,
  MuCheckbox,
  MuDatepicker,
  MuTimepicker,
  MuTree,
  MuSwitch,
  MuCascader,
  MuSelectTree ,
  MuSelectTable,
  MuSelectAdd,
  MuSearchHigh,
  MuSearchInput,
  MuRadioGroup,
  // DtTemplate,
  MuTreeSelect,
  // DtIcon
}


const install = function(Vue: any, opts: any) {

  Object.keys(components).forEach(key => {
    Vue.component(key, (components as { [key: string]: Function })[key]);
  });

  Object.keys(directives).forEach(key => {
    Vue.directive(key, (directives as { [key: string]: DirectiveOptions })[key]);
  });

  Vue.prototype.$MuToast = MuToast;

  Vue.prototype.$mu = prototype;
}


/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  MuRow,
  MuCol,
  MuBtn,
  MuBtnBar,
  MuTag,
  MuImage,
  MuCarousel,
  MuPagination,
  // DtCollapse,
  // DtCollapseItem,
  MuFormItem,
  MuInput,
  MuSelect,
  MuSelectInput,
  MuInputPassword,
  MuTextarea,
  MuInputNumber,
  MuForm,
  MuTable,
  MuTableColumn,
  // DtField,
  MuDialog,
  MuTabs,
  MuFilterBar,
  MuTooltip,
  MuRadio,
  MuCheckbox,
  MuDatepicker,
  MuTimepicker,
  MuTree,
  MuSwitch,
  MuCascader,
  MuSelectTree ,
  MuSelectTable,
  MuSelectAdd,
  MuSearchHigh,
  MuSearchInput,
  MuRadioGroup,
  // DtTemplate,
  MuTreeSelect,
  // DtIcon
};
